// extracted by mini-css-extract-plugin
export default {"container":"g1LtfLOZmwBnf09yhBOf","layout-simple":"CxidC91tAvNvJ6DtNmfl","layout-grid":"sKLV4v2bqDmbmOQCMLpB","layout-flex":"ACV3Amt6eMX1RrqDYe6z"};